import React from "react";
import IconCollection from '../../IconCollection/IconCollection';

const GameLogComponent = ({
  game_data,
  game_log,
  matchData,
  teamOneColor,
  teamTwoColor,
  teamOneName,
  teamTwoName,
  findJerseyNumber,
  findPlayerName,
  setScoreDeleteModal,
  setScoreId,
}) => {


  if (!game_data) {
    return (
      <p className="text-center font-bebas text-2xl text-[#4A4A4A]">
        No Log Found
      </p>
    );
  }

  return (
    <>
      {game_log?.length > 0 &&
        game_log
          ?.sort((a, b) => a.seq - b.seq)
          .filter((log) => log.score_period?.trim() !== "NotStarted")
          .filter((log) => log.score_type?.trim() !== "init")
          .map((log, index) => (
            <div
              key={index}
              className={`max-w-[225px] p-1 lg:p-3 w-full  flex relative items-start border-[1px] border-l-[4px] rounded-sm`}
              style={{
                borderColor:
                  log.t_id === matchData.event_team_a_id
                    ? teamOneColor
                    : teamTwoColor,
              }}
            >
              <div className="flex-1">
                <p
                  className={`font-bebas  text-[12px] lg:text-xl`}
                  style={{
                    color:
                      log.t_id === matchData.event_team_a_id
                        ? teamOneColor
                        : teamTwoColor,
                  }}
                >
                  {log.score_type === "point1" && "1pt made"}
                  {log.score_type === "point2" && "2pt made"}
                  {log.score_type === "point3" && "3pt made"}
                  {log.score_type === "pointMiss1" && "1pt miss"}
                  {log.score_type === "pointMiss2" && "2pt miss"}
                  {log.score_type === "pointMiss3" && "3pt miss"}
                  {log.score_type === "assist" && "Assist"}
                  {log.score_type === "offensiveRebound" && "Offensive rebound"}
                  {log.score_type === "defensiveRebound" && "Defensive rebound"}
                  {log.score_type === "block" && "Block"}
                  {log.score_type === "steal" && "Steal"}
                  {log.score_type === "turnover" && "Turnover"}
                  {log.score_type === "personalFoul" && "Personal Foul"}
                  {log.score_type === "foulDrawn" && "Foul Drawn"}
                  {log.score_type === "technicalFoul" && "Technical Foul"}
                </p>
                <p
                  className={`font-bebas  text-[8px] lg:text-xl`}
                  style={{
                    color:
                      log.t_id === matchData.event_team_a_id
                        ? teamOneColor
                        : teamTwoColor,
                  }}
                >
                  {!log.score_type && "Substitutions"}
                </p>
                {!log.score_type && (
                  <div className="flex flex-col gap-1 lg:gap-2 mt-1">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <div key={i} className="flex flex-col gap-1 lg:gap-2">
                        <div className="flex gap-1 lg:gap-2 items-center">
                          <div className="max-w-[16px] lg:max-w-[34px] font-montserrat uppercase text-light font-semibold text-[4px] lg:text-[10px] w-full h-[10px] lg:h-5 bg-[#63D799] rounded-sm flex justify-center items-center">
                            in
                          </div>
                          <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
                            &nbsp; | #{" "}
                            {findJerseyNumber(log.t_id, log[`r_id_${i}_new`])} |
                            &nbsp;{" "}
                            {findPlayerName(log.t_id, log[`r_id_${i}_new`])}
                          </p>
                        </div>
                        <div className="flex gap-1 lg:gap-2 items-center">
                          <div className="max-w-[16px] lg:max-w-[34px] font-montserrat uppercase text-light font-semibold text-[4px] lg:text-[10px] w-full h-[10px] lg:h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center">
                            out
                          </div>
                          <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
                            &nbsp; | #{" "}
                            {findJerseyNumber(log.t_id, log[`r_id_${i}_org`])} |
                            &nbsp;{" "}
                            {findPlayerName(log.t_id, log[`r_id_${i}_org`])}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {log.score_type && (
                  <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
                    {log.t_id === matchData.event_team_a_id && teamOneName}
                    {log.t_id === matchData.event_team_b_id && teamTwoName}
                    &nbsp; | # {findJerseyNumber(log.t_id, log.r_id)} | &nbsp;
                    {findPlayerName(log.t_id, log.r_id)}
                  </p>
                )}
              </div>

              <div className="flex gap-1 lg:gap-2 max-w-10 items-center top-[-4px] lg:top-auto justify-between absolute right-1">
                {log?.star && (
                  <div>
                    <IconCollection
                      customClass="lg:max-w-4 max-w-[8px] w-full lg:h-4 h-[8px]"
                      name="star-color-icon"
                    />
                  </div>
                )}

                {log.type && (
                  <button
                    onClick={() => [
                      setScoreDeleteModal(true),
                      setScoreId({
                        type: log.type,
                        data_id: log.data_id,
                        eg_id: log.eg_id,
                        event_id: log.event_id,
                        score_timer: log.score_timer,
                        score_period: log.score_period,
                      }),
                    ]}
                  >
                    <IconCollection
                      name="delete-icon"
                      customClass="lg:max-w-4 max-w-[8px] w-full lg:h-4 h-[8px]"
                    />
                  </button>
                )}


              </div>
               {log.user_detail &&

                  <p className='absolute w-fit bottom-0 right-2 text-xs font-bebas text-blue-800'>
                  <i>

                    {log.user_detail.code}
                    </i>
                  </p>
                }
            </div>
          ))}
    </>
  );
};

export default GameLogComponent;
